import React, { useState } from 'react';
import AdSpacePhotosAdminList from './components/AdSpacePhotosAdminList';
import AdSpacePhotosAdminAddPhotoPage from './components/AdSpacePhotosAdminAddPhotoPage';
import { Box, Tabs, Tab } from '@mui/material';



const AdSpacePhotosAdminPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="AdSpaces admin tabs">
        <Tab label="List adSpace Photos" />
        <Tab label="Insert adSpace Photo" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <AdSpacePhotosAdminList />}
        {tab === 1 && <AdSpacePhotosAdminAddPhotoPage />}
      </Box>
    </Box>
  );
};

export default AdSpacePhotosAdminPage;